import { useState } from "react";
import "./Certification.css";

function Certification() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    enrollmentNumber: "",
    phone: "",
    dateOfBirth: "",
    course: "",
    certificateType: "",
    completionDate: "",
    reason: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    alert("🎓 Certification Application Submitted Successfully!");

    setFormData({
      name: "",
      email: "",
      enrollmentNumber: "",
      phone: "",
      dateOfBirth: "",
      course: "",
      certificateType: "",
      completionDate: "",
      reason: "",
    });
  };

  return (
    <div id="student-certificates" className="student-page-certification-section" data-aos="fade-up" data-aos-duration="700">
      <div className="student-page-certification-card" data-aos="fade-left" data-aos-delay="80" data-aos-duration="700">
        <div className="student-page-certification-title">
          <h2>Certification Application</h2>
          <p>Apply for your course completion certificate.</p>
        </div>

        <form onSubmit={handleSubmit} data-aos="fade-up" data-aos-delay="140" data-aos-duration="650">
          <div className="student-page-certification-input-grid">
            <div className="student-page-certification-input-group">
              <label>Student Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="student-page-certification-input-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="student-page-certification-input-group">
              <label>Enrollment Number</label>
              <input
                type="text"
                name="enrollmentNumber"
                placeholder="Enter your enrollment number"
                value={formData.enrollmentNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="student-page-certification-input-group">
              <label>Phone Number</label>
              <input
                type="tel"
                name="phone"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="student-page-certification-input-group">
              <label>Date of Birth</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="student-page-certification-input-group">
            <label>Select Course</label>
            <select name="course" value={formData.course} onChange={handleChange} required>
              <option value="">Choose Course</option>
              <option>Full Stack Development</option>
              <option>Python Programming</option>
              <option>Java Development</option>
              <option>UI/UX Design</option>
            </select>
          </div>

          <div className="student-page-certification-input-grid">
            <div className="student-page-certification-input-group">
              <label>Certificate Type</label>
              <select
                name="certificateType"
                value={formData.certificateType}
                onChange={handleChange}
                required
              >
                <option value="">Choose certificate type</option>
                <option value="completion">Course Completion Certificate</option>
                <option value="participation">Participation Certificate</option>
                <option value="merit">Merit Certificate</option>
              </select>
            </div>

            <div className="student-page-certification-input-group">
              <label>Course Completion Date</label>
              <input
                type="date"
                name="completionDate"
                value={formData.completionDate}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="student-page-certification-input-group">
            <label>Reason</label>
            <textarea
              name="reason"
              placeholder="Write your reason..."
              value={formData.reason}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="student-page-certification-button">
            Apply for Certificate
          </button>
        </form>
      </div>
    </div>
  );
}

export default Certification;
